import { ActionReducerMap } from "@ngrx/store";
import { FRReducer } from "./fr-reducers";
import { pendingChangesReducer } from "app/core/store/reducers/pending-changes.reducers";
import { excelConnectorCurrentReducer } from "./excel-connector-current.reducers";

export const MANAGE_FR_REDUCER: ActionReducerMap<IFRGState> = {
  formsRecognizerConfiguration: FRReducer
};
